export enum ApplicationDetailsProperties {
  RowKey = 'Application Name',
  PartitionKey = 'Application Type',
  TimeStamp = 'TimeStamp',
  Description = 'Description',
  ActiveDirAppId = 'Active Directory AppId',
  ActiveDirTenant = 'Tenant',
  AppInsightInstrumentKey = 'AppInsight Instrument Key',
  AppInsightAppId = 'AppInsight AppId',
  AppInsightApiKey = 'AppInsight Api Key',
  AppInsightUrl = 'AppInsight Url',
  AppInfoUrls = 'Application information urls',
}
